module.exports = __webpack_public_path__ + "img/o.5d905dca.jpg";